<mat-radio-group (change)="change($event)" class="card-select-radio-group" *ngIf="products != null && products.length > 0">
  <table>
    <tr *ngFor="let product of products" class="card-row card-transition" (click)="productRadioButton._inputElement.nativeElement.click()">
      <td>
        <img class="card-img card-transition" [src]="product.logoUrl" alt="{{product.name}} Preview" />
      </td>
      <td class="card-product-information card-transition">
        {{product.name}}<br>
        <small class="card-transition">{{"ORDER.PRODUCT.INCLUDING_ISSUING_FEE" | translate : {annualFee:product.annualFee.toFixed(2), issuingFee:product.issuingFee.toFixed(2)} }}</small>
      </td>
      <td>
        <mat-radio-button class="card-select-radio-button card-transition" #productRadioButton [checked]="product.checked" [value]="product.id" (click)="writeValue(productRadioButton.value)"></mat-radio-button>
      </td>
    </tr>
  </table>
</mat-radio-group>
<span *ngIf="products == null || products.length == 0">
  {{"ORDER.PRODUCT.EMPTYLIST" | translate}}
</span>
